/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-19 14:42:59
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-30 11:42:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/Preview/index.tsx
 */
import React from 'react';

import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import {
  CheckoutBottom,
  CheckoutTabBars,
  CheckoutTotalPrice,
  CustomizationPageCaption as CustomizationCaption,
  CustomizationPageHeader as CustomizationHeader,
  CustomizationPageService as CustomizationService,
  ProductCartItem,
} from 'unifyxp-ecomm-components';

import styles from './style.module.less';

import { useSelector } from 'react-redux';
import { withDraggableId } from 'src/constrains/Preview/util';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCustomisationButton,
  getMockupImage,
  getPageEnabled,
  getSelectedServiceAndTc,
  getService,
  onCollapseOpen,
} from '../slice';
const _CustomizationService = withDraggableId(
  CustomizationService,
  EnumCollapseId.service,
  onCollapseOpen,
);

const _CustomizationCaption = withDraggableId(
  CustomizationCaption,
  EnumCollapseId.mockupImage,
  onCollapseOpen,
);

const NoticeBoard = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    customisationButtonText,
    customisationButtonTextColor,
    customisationButtonBorderColor,
  } = props;
  return (
    <div className={styles.noticeBoardContainer}>
      <div>
        <div className={styles.noticeBoardCartContainer}>
          <ProductCartItem
            showChecked
            showCounter
            showDelete
            showPrice
            showCustomisationButton
            customisationButtonText={customisationButtonText}
            customisationButtonTextColor={customisationButtonTextColor}
            customisationButtonBorderColor={customisationButtonBorderColor}
            checked
            price={12.0}
            currency={'HKD'}
            secondCurrency={'RMB'}
            secondPrice={13.0}
            title={getI18n('salesChannelProductCustomization.index.mario')}
            desc={getI18n('salesChannelProductCustomization.index.mario')}
            imageUrl={
              'https://image-uat.unifyxp.com/images/Product/8ac07265-af63-4471-a4aa-8f3ba947b0ee.png'
            }
          />
        </div>
        <div className={styles.tipsContainer}>
          {getI18n(
            'salesChannelProductCustomization.index.previewTipsContainer',
          )}
        </div>
        <div className={styles.checkStand}>
          <p>
            <span>总价</span> <span>HKD 12.0</span>
          </p>
          <p className={styles.total}>
            <span>合計</span> <span>HKD 12.0</span>
          </p>
          <p className={styles.about}>
            <span></span> <span>≈ RMB 13.0</span>
          </p>
        </div>
      </div>
      <div>
        <CheckoutTotalPrice
          currency={'HKD'}
          sum={100}
          total={120}
          approxCurrency={'RMB'}
          approxTotal={140}
        />
        <CheckoutBottom />
      </div>
    </div>
  );
};

const _CustomisationButton = withDraggableId(
  NoticeBoard,
  EnumCollapseId.customisationButton,
  onCollapseOpen,
);
// const _ProductGrid = withDraggableId(
//   ProductGrid,
//   EnumCollapseId.productMenu,
//   onCollapseOpen,
// );

function Preview({ translationEnabled }: { translationEnabled: boolean }) {
  const enabled = useSelector(getPageEnabled());
  const mockupImage = useSelector(getMockupImage());
  //console.log('mockupImage', mockupImage);
  const service = useSelector(getService());
  const customisationButton = useSelector(getCustomisationButton());
  const { selectedServiceUuid, termsAndConditionsUuid } = service || {};
  const { text, outlineColour, textColour } = customisationButton || {};
  const { service: _s }: any = useSelector(
    getSelectedServiceAndTc(selectedServiceUuid, termsAndConditionsUuid),
  );
  //console.log('preview _s', _s);
  const _open = useSelector(
    getCollapseOpenStatus(EnumCollapseId.customisationButton),
  );
  // const data = {
  //   enabled,
  //   mockupImage,
  //   ...(service || {}),
  //   tc,
  //   service: _s,
  // };
  // const _data: any = getContent(useSelector);
  // const { productMenu, topLeaderBoardBanner } = _data;
  // const { enabled: _tEnabled, linkModule } = topLeaderBoardBanner;
  // const { enabled: _mEnabled, roots } = productMenu;
  // const { linkImage } = linkModule || {};
  // const { url } = linkImage || {};

  return (
    <PreviewContainer
      {...(_open ? { wrapperClassName: styles.wrapperBackground } : {})}
      //containerStyle={!_open ? { background: background || '#fff' } : {}}
      {...(_open ? { header: <CheckoutTabBars /> } : {})}
      className={styles.container}
      style={translationEnabled ? { top: '65px' } : {}}>
      {_open ? (
        <_CustomisationButton
          customisationButtonText={text}
          customisationButtonTextColor={textColour}
          customisationButtonBorderColor={outlineColour}
        />
      ) : (
        <CustomizationHeader>
          {enabled && (
            <React.Fragment>
              <_CustomizationCaption mockupImage={mockupImage} />
              <_CustomizationService
                selectedServiceUuid={selectedServiceUuid}
                termsAndConditionsUuid={termsAndConditionsUuid}
                service={_s}
                //tc={tc}
              />
            </React.Fragment>
          )}
        </CustomizationHeader>
      )}
    </PreviewContainer>
  );
}

export default Preview;
